import { Pipe, PipeTransform,Input } from '@angular/core';
import { AuthService } from '../services/auth.service';
import * as _ from 'lodash';


@Pipe({name: 'roleFilter'})
export class RoleFilterPipe implements PipeTransform{
    @Input()
    roles

    constructor(private authService: AuthService){
        
    }

    transform(items){
        return _.filter(items,(i) => {
            let permittedRoles = this.roles ? this.roles :  i.roles
            return permittedRoles ? _.some(this.authService.getUserRoles(),(r) => _.includes(permittedRoles,r)) : true
        })
    }
}